import { useLocation } from "@solidjs/router";
import { createEffect, createSignal, type JSX } from "solid-js";
import { MarketingFooter } from "~/components/marketing/MarketingFooter";
import { MarketingHeader } from "~/components/marketing/MarketingHeader";
import { findSection } from "~/components/marketing/sections";
import { MarketingVideoProvider, VideoPlayer } from "~/components/marketing/video";

export function MarketingLayout(props: { children: JSX.Element }) {
  const location = useLocation();
  const [scrollContainer, setScrollContainer] = createSignal<HTMLElement | undefined>();

  createEffect(() => {
    // Track pathname so this effect re-runs on every route change inside the marketing group.
    location.pathname;
    const el = scrollContainer();
    if (!el) return;
    queueMicrotask(() => {
      // A link to a section (the homepage's "See how" links, or a section's name) lands on it, not
      // the top of the page.
      const id = location.hash.slice(1) || findSection(location.pathname, location.query.s)?.id;
      const target = id && document.getElementById(id);
      if (target) return target.scrollIntoView();
      el.scrollTo(0, 0);
      window.scrollTo(0, 0);
    });
  });

  return (
    <MarketingVideoProvider>
      <div class="flex h-screen min-w-0 flex-col bg-canvas text-primary-text">
        <MarketingHeader />
        <main ref={setScrollContainer} class="scrollbar-show-on-hover min-h-0 flex-1 overflow-y-auto">
          <div class="relative flex min-h-full flex-col pt-16">
            <VideoPlayer />
            <div class="flex-1">{props.children}</div>
            <MarketingFooter />
          </div>
        </main>
      </div>
    </MarketingVideoProvider>
  );
}
